import { Card, CardContent, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';

type StatTileProps = {
  label: string;
  value: string | number;
  hint?: string;
  accent?: ReactNode;
};

export const StatTile = ({ label, value, hint, accent }: StatTileProps) => (
  <Card
    variant="outlined"
    sx={{
      height: '100%',
      transition: 'border-color 140ms ease',
      '&:hover': { borderColor: 'primary.main' },
    }}
  >
    <CardContent sx={{ py: 2.25, '&:last-child': { pb: 2.25 } }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="overline" color="text.secondary">
          {label}
        </Typography>
        {accent}
      </Stack>
      <Typography
        variant="h4"
        sx={{ mt: 0.5, fontVariantNumeric: 'tabular-nums', letterSpacing: '-0.025em' }}
      >
        {value}
      </Typography>
      {hint ? (
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.25 }}>
          {hint}
        </Typography>
      ) : null}
    </CardContent>
  </Card>
);
